import React, { useState, useContext, useEffect, useRef } from "react";
import { useParams } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { Button, CircularProgress } from "@material-ui/core";
import { Redirect, useHistory } from "react-router-dom";
import { useMediaQuery } from "react-responsive";

import IntellipayLogo from "../images/intellipay-dark.png";
import RevealPasswordInput from "../components/RevealPasswordInput";

import { Context as PortalContext } from "../context/portal.context.js";
import { Context as AuthContext } from "../context/auth.context.js";

import ValidateEmail from "../helpers/ValidateEmail.js";
import { useCookies } from "react-cookie";

import ForgotPassword from "../components/ForgotPassword";

const Login = (props) => {
	const [errorVisible, setErrorVisible] = useState(false);
	const [accountErrorVisible, setAccountErrorVisible] = useState(false);
	const [loginOption, setLoginOption] = useState('quick');
	const [buttonText, setButtonText] = useState('Find Invoices');
	const [fields, setFields] = useState([]);
	const [email, setEmail] = useState('');
	const [username, setUsername] = useState('');
	const [password, setPassword] = useState('');
	const [loading, setLoading] = useState(false);
	const [retypePassword, setRetypePassword] = useState('');
	const [emailValid, setEmailValid] = useState(false);
	//const [view, setView] = useState("createAccountValidation");
	const [view, setView] = useState('login');
	const [cookies, setCookie, removeCookie] = useCookies('sessionID');
	const [keyPressed, setKeyPressed] = useState(false);
	const [glcodeValid, setGlcodeValid] = useState(false);
	const [buttonDisabled, setButtonDisabled] = useState(true);
	const [usesGlcode, setUsesGlcode] = useState(false);
	const [glcode, setGlcode] = useState(null);
	const [customerBackgroundImage, setCustomerBackgroundImage] = useState("")
	const textRef = useRef()
	const [hideLoginOption, setHideLoginOption] = useState(false);



	let history = useHistory();

	const { state, reHydratePortal, hydratePortal, getExternalProviderTransactions } = useContext(PortalContext);
	const portalState = useContext(PortalContext);
	const {
		login,
		logout,
		validate,
		forgotPassword,
		forgotUsernameAndPassword,
		forgotUsername,
		createAccount,
		clearErrors,
		getSession,
	} = useContext(AuthContext);
	const authState = useContext(AuthContext);

	useEffect(() => {
		if (portalState.state?.portalHydrated) {
			setCustomerBackgroundImage(`url(${portalState.state?.merchantBackgroundImage})`)
		}
	}, [portalState])

	const isTabletOrMobile = useMediaQuery({ query: '(max-width: 1224px)' });

	let { op } = useParams();
	let queryString = window.location.search;

	let params = new URLSearchParams(queryString);

	let walletOnly = 0;
	if (params.has('walletOnly'))
		walletOnly = params.get('walletOnly');

	// allowing overrides from the portalState
        if (walletOnly != 1 && portalState.state.walletOnly == 1) {
                walletOnly = 1;
        }

	useEffect(() => {
		// let newFields = {};
		// Object.keys(state.fields).map((field) => {
		//   newFields = { ...newFields, [state.fields[field]]: "" };
		// });

		// setFields(newFields);


		if (state.glcode_list && state.externalProvider != "daffron") {
			setUsesGlcode(true);
		}
		const queryString = window.location.search;
		const urlParams = new URLSearchParams(queryString);

		if (urlParams.has('glcode')) {
			setGlcode(urlParams.get('glcode'));
			Object.keys(state.glcode_list).map((index) => {
				if (urlParams.get('glcode') === state.glcode_list[index].code) {
					return setGlcodeValid(true);
				}
			});
		}

		if (Object.keys(state.glcode_list).length === 0) {
			setGlcodeValid(true);
		}

		if (state.current_glcode_string != null && state.current_glcode_string != "") {
			setGlcodeValid(true);
		}

		if (authState.state.authenticated) {
			if (typeof(walletOnly) != "undefined" && walletOnly == 1) {
				history.push(`/${op}/wallet?walletOnly=1`);
			} else {
				history.push(`/${op}/invoices`);
			}
		}
	}, []);

	function handleSubmit(event) {
		loginCustomer();

		event.preventDefault();
	}

	function handleValidate(event) {
		validate({ fields, merchantID: state.merchantID, reHydratePortal, op, getExternalProviderTransactions });

		event.preventDefault();
	}

	function validateFields(allFields) {
		let fieldsValid = false;
		const validate = () => {
			let valid = false;

			if (allFields.length === Object.keys(state.fields).length) {
				valid = true;
			}

			allFields.forEach((field, index) => {
				if (field[`var${index + 1}`] === '') {
					valid = false;
				}
			});



			return valid;
		};


		fieldsValid = validate();

		if (usesGlcode) {
			if (glcodeValid && fieldsValid) {
				setButtonDisabled(false);
			} else {
				setButtonDisabled(true);
			}
		} else {
			if (fieldsValid) {
				setButtonDisabled(false);
			} else {
				setButtonDisabled(true);
			}
		}
	}

	function stringToHTML(str) {
		var dom = document.createElement('div');
		dom.innerHTML = str;
		return dom;
	}

	function loginCustomer() {

		login({
			username,
			password,
			setCookie,
			removeCookie,
			history,
			merchantID: state.merchantID,
			reHydratePortal,
			getExternalProviderTransactions,
			op,
		});
	}

useEffect(() => {
	let htmlFromBackend = state.loginMessage;
	if (htmlFromBackend && textRef.current){
		textRef.current.innerHTML = htmlFromBackend
	}


	if(state.hideLoginOption){
	// 	console.log("setting login option to full");
		setLoginOption('full');
		setHideLoginOption(true);
	}

})
	
	function renderView() {
		switch (view) {
			case 'login':
				return (
					
					<>
               <img
					src={
						state.merchantLogoURL != '' && state.merchantLogoURL?.split(".com")[1].includes(".")
						? state.merchantLogoURL
						: (state.verticalMarketLogo && state.verticalMarketLogo != ''? state.verticalMarketLogo : "https://secure.cpteller.com/img/logos/CPTellerLogo.png")
					}
					style={{ height: "100%", maxWidth: "95%" }}
					alt={"merchant-logo"}
            	/>


						<div style={styles.inputsContainer} className="login-wrapper">		
							<div style={styles.left}>
								{/*<img src={PlanoImage} height={70} style={{ marginBottom: 50 }} />*/}
								{ !hideLoginOption && (
									<div style={{...styles.loginOption, width: state.loginMessage ? "100%" : "300px"}} >
										{!walletOnly && (<Button
											variant="text"
											disabled={
												loginOption === 'quick'
													? true
													: false
											}
											style={{
												width: "137px",
												borderBottom:
													loginOption === 'quick'
														? '2px solid #84BD00'
														: 'none',
												borderRadius: 0,
												color:
													loginOption === 'quick'
														? '#063775'
														: 'grey',
												
											}}
											onClick={() => {
												setLoginOption('quick');
												setButtonText('Find Invoices');
												setErrorVisible(false);
												setEmail('');
												setPassword('');
												setFields([]);
												validateFields([]);
												clearErrors();
											}}
										>
											<x-lang>Pay As Guest</x-lang>
										</Button>)}
										{state.externalProvider != "daffron" && (
										<Button
											variant="text"
											color="primary"
											disabled={
												loginOption === 'full'
													? true
													: false
											}
											style={{
												borderBottom:
													loginOption === 'full'
														? '2px solid #84BD00'
														: 'none',
												borderRadius: 0,
												color:
													loginOption === 'full' || walletOnly
														? '#063775'
														: 'grey',
												width: 140,
											}}

											onClick={() => {
												setLoginOption('full');
												setButtonText('Login');
												setAccountErrorVisible(false);
												clearErrors();
											}}
										>
											<x-lang>Account Login</x-lang>
										</Button>
										)}
									</div>
								)}
								{loginOption === 'full' || walletOnly ? (
									<form
										onSubmit={handleSubmit}
										style={{
											display: 'flex',
											flexDirection: 'column',
											alignItems: 'center',
										}}
									>
										<label
											style={{
												color: '#2f343b',

												display: 'flex',
												alignSelf: 'flex-start',
												marginBottom: 8,
											}}
										>
											<x-lang>Username</x-lang>
										</label>
										<input
											type="text"
											value={username}
											autoCapitalize="none"
											onChange={(e) => {
												setUsername(e.target.value);
												//setEmailValid(ValidateEmail(e.target.value));
											}}
											id="intellipay-email"
											style={{
												height: 40,
												width: "100%",
												borderRadius: 6,
												border: '1px solid #d3dce0',
												boxShadow:
													'inset 0px 0px 0px 0px',
												outline: 'none',
												borderStyle: 'solid',
												paddingLeft: 8,
												paddingRight: 8,
												fontSize: '1rem',
												fontWeight: 400,
												marginBottom: 25,
												textTransform: 'lowercase',
											}}
										/>
										<label
											style={{
												color: '#2f343b',
												display: 'flex',
												alignSelf: 'flex-start',
												marginBottom: 8,
											}}
										>
											<x-lang>Password</x-lang>
										</label>
										<RevealPasswordInput value={password}
											onChange={(e) =>
												setPassword(e.target.value)
											}
											id="intellipay-password"
											style={{
												height: 40,
												width: "100%",
												borderRadius: 6,
												border: '1px solid #d3dce0',
												outline: 'none',
												paddingLeft: 8,
												paddingRight: 8,
												fontSize: '1rem',
												fontWeight: 400,
												marginBottom: 25,
											}}
										/>
										{authState.state.loginError ? (
											<div style={styles.noAccountBox}>
												<span style={{ color: 'red' }}>
												<x-lang>Incorrect username or
													password</x-lang>
												</span>
											</div>
										) : null}
										<Button
											type="submit"
											variant="contained"
											color="primary"
											disableElevation
											style={{
												width: 200,
												height: 40,
												borderRadius: 25,
												color: 'white',
												marginTop: 15,
											}}
										>
											{authState.state.loggingIn ? (
												<CircularProgress
													style={{ color: 'white' }}
													size={15}
												/>
											) : (
												'Login'
											)}
										</Button>
									</form>
								) : (
									<form
										onSubmit={handleValidate}
										style={{
											display: 'flex',
											flexDirection: 'column',
											alignItems: 'center',
										}}
									>
										{state.externalProvider == "daffron" && (
											<div>
												{Object.keys(state.glcode_list).map((item) =>
													{	
														if (state.glcode_list[item].name == "Utilities") {
																return (
																	<input type="hidden" id={`intellipay-glcode`} value={state.glcode_list[item].code} />
																);
														}
													}
												)}
											</div>
                                                                                )}

										{state.externalProvider != "daffron" && state.glcode && (
											<div
												style={{
													width: '100%',
													marginBottom: 25,
												}}
											>
												<label
													style={{
														color: '#004786',
														fontWeight: 700,
														display: 'flex',
														alignSelf: 'flex-start',
														marginBottom: 8,
													}}
												>
													<x-lang>Department</x-lang>
												</label>
												<select
													type="text"
													id={`intellipay-glcode-select`}
													onChange={(e) => {
														setGlcode(
															e.target.value
														);
														setGlcodeValid(true);
														hydratePortal({
															op,
															glcode: e.target
																.value,
															getSession,
															history,
															getExternalProviderTransactions,
															queryString: `?glcode=${e.target.value}`,
														});
														// (window.location.href = `${window.location.pathname}?glcode=${e.target.value}`)
													}}
													style={{
														height: 44,
														width: '100%',
														borderRadius: 6,
														border: '1px solid #d3dce0',
														outline: 'none',
														paddingLeft: 8,
														paddingRight: 8,
														fontSize: '1rem',
														fontWeight: 400,
														cursor: 'pointer',
														paddingRight: 10,
													}}
												>
													<option selected disabled>
													<x-lang>Select a department</x-lang>...
													</option>
													{Object.keys(
														state.glcode_list
													).map((item) => {
														return (
															<option
																value={
																	state
																		.glcode_list[
																		item
																	].code
																}
																selected={
																	state
																		.glcode_list[
																		item
																	].code ===
																	state
																		.current_glcode
																		.code
																}
															>
																{
																	state
																		.glcode_list[
																		item
																	].name
																}
															</option>
														);
													})}
												</select>
											</div>
										)}
										{Object.keys(state.fields).map(
											(field) => {
												return (
													<div
														className="login-form"
														key={field}
														style={{
															width: state.loginMessage ? "100%" : "300px",
															marginRight: 20,
															marginBottom: 25,
														}}
													>
														<label
															style={{
																color: '#004786',
																fontWeight: 700,
																display: 'flex',
																alignSelf:
																	'flex-start',
																marginBottom: 8,
															}}
														>
															{
																state.fields[
																	field
																].displayName
															}
														</label>
														{state.fields[field]
															.preText && (
															<label
																style={{
																	color: '#2f343b',
																	flexWrap:
																		'wrap',
																	display:
																		'flex',
																	alignSelf:
																		'flex-start',
																	textAlign:
																		'left',
																	marginBottom: 8,
																	marginTop: 8,
																	fontSize: 12,
																}}
																dangerouslySetInnerHTML={{
																	__html: state
																		.fields[
																		field
																	].preText,
																}}
															/>
														)}

														<input
															type={state.fields[field].password ? 'password' : 'text'}
															id={`intellipay-${state.fields[field].fieldName}`}
															onChange={(e) => {
																setFieldValue({
																	field,
																	value: e
																		.target
																		.value,
																});
																validateFields(
																	fields
																);
															}}
															placeholder={
																state.fields[
																	field
																].placeholder
															}
															style={{
																height: 40,
																width: state.loginMessage ? "100%" : "300px",
																borderRadius: 6,
																border: '1px solid #d3dce0',
																outline: 'none',
																paddingLeft: 8,
																paddingRight: 8,
																fontSize:
																	'1rem',
																fontWeight: 400,
															}}
														/>
														{state.fields[field]
															.postText && (
															<label
																style={{
																	color: '#2f343b',
																	flexWrap:
																		'wrap',
																	display:
																		'flex',
																	alignSelf:
																		'flex-start',
																	textAlign:
																		'left',
																	marginTop: 8,
																	fontSize: 12,
																}}
																dangerouslySetInnerHTML={{
																	__html: state
																		.fields[
																		field
																	].postText,
																}}
															/>
														)}
													</div>
												);
											}
										)}

										{authState.state.validateError ? (
											<div style={styles.noAccountBox}>
												<span style={{ color: 'red' }}>
												<x-lang>Can't find account</x-lang>
												</span>
											</div>
										) : null}
										<Button
											type="submit"
											variant="contained"
											color="primary"
											disableElevation
											disabled={buttonDisabled}
											style={{
												width: 200,
												height: 40,
												borderRadius: 25,
												color: 'white',
												marginTop: 15,
											}}
										>
											{authState.state.loggingIn ? (
												<CircularProgress
													style={{ color: 'white' }}
													size={15}
												/>
											) : (
												'Find Invoices'
											)}
										</Button>
									</form>
								)}
							</div>

							{
								state.loginMessage && <div className="notice-wrapper"  ref={textRef} />
							}
							
							
						</div>

						{loginOption === 'full' || walletOnly ? (
							<div style={styles.linksContainer}>
								<div style={styles.noAccountBox}>
									<Button
										onClick={() =>
											setView('forgotPassword')
										}
										style={{
											color: '#1C9BDD',
											marginTop: 15,
										}}
									>
										<x-lang>Forgot password</x-lang>?
									</Button>
								</div>
								
								{portalState.state.dealerMerchant ? (
									<div style={styles.noAccountBox}>
										<Button
											onClick={() =>
												setView('forgotUsernameAndPassword')
											}
										style={{ color: '#1C9BDD' }}
										>
											<x-lang>Forgot username and password</x-lang>?
										</Button>
									</div>
								) : (
									<div style={styles.noAccountBox}>
										<Button
											onClick={() =>
												setView('forgotUsername')
											}
										style={{ color: '#1C9BDD' }}
										>
											<x-lang>Forgot username</x-lang>?
										</Button>
									</div>
								)}
								
								<div style={styles.noAccountBox}>
									<Button
										onClick={() =>
											setView('createAccountValidation')
										}
										style={{ color: '#1C9BDD' }}
									>
										<x-lang>Don't have an account? Sign up</x-lang>
									</Button>
								</div>
								{/* <div style={styles.noAccountBox}>
                  <Button
                    onClick={() => alert("yo")}
                    style={{ color: "#1C9BDD" }}
                  >
                    Why create an account?
                  </Button>
                </div> */}
							</div>
						) : null}
						<div
							style={{
								display: 'flex',
								flexDirection: 'row',
								alignItems: 'center',
								marginTop: 40,
								color: 'grey',
							}}
						>
							<span style={{ marginRight: 8 }}><x-lang>Powered By</x-lang></span>
							<img src={IntellipayLogo} height={25} alt="logo" />
						</div>
					</>
				);
			case 'forgotPassword':
			case 'forgotUsernameAndPassword':
			case 'forgotUsername':
				return (
				<>
					
					<img
						src={
							state.merchantLogoURL != '' && state.merchantLogoURL?.split(".com")[1].includes(".")
							? state.merchantLogoURL
							: (state.verticalMarketLogo && state.verticalMarketLogo != ''? state.verticalMarketLogo : "https://secure.cpteller.com/img/logos/CPTellerLogo.png")
						}
					style={{ height: "100%", maxWidth: "95%" }}
					alt={"merchant-logo"}
					/>
					<ForgotPassword setLoading={setLoading} setView={setView} view={view} />
				</>
				);
      		case "createAccountValidation":
				return (
				<>
					<img
						src={
							state.merchantLogoURL != '' && state.merchantLogoURL?.split(".com")[1].includes(".")
							? state.merchantLogoURL
							: (state.verticalMarketLogo && state.verticalMarketLogo != ''? state.verticalMarketLogo : "https://secure.cpteller.com/img/logos/CPTellerLogo.png")
						}
					style={{ height: "100%", maxWidth: "95%" }}
					alt={"merchant-logo"}
					/>
							<div
								style={{
									marginTop: 25,
									display: 'flex',
									flexDirection: 'column',
									alignItems: 'center',
								}}
							>
								{state.externalProvider == "daffron" && (
									<div>
										{Object.keys(state.glcode_list).map((item) =>
											{
												if (state.glcode_list[item].name == "Utilities") {
													return (
														<input type="hidden" id={`intellipay-glcode`} value={state.glcode_list[item].code} />
													);
												}
											}
										)}
									</div>
								)}

								{state.externalProvider != "daffron" && state.glcode && (
									<div
										style={{
											width: '100%',
											marginBottom: 25,
										}}
									>
										<label
											style={{
												color: '#004786',
												fontWeight: 700,
												display: 'flex',
												alignSelf: 'flex-start',
												marginBottom: 8,
											}}
										>
											<x-lang>Department</x-lang>
										</label>
										<select
											type="text"
											id={`intellipay-glcode-select`}
											onChange={(e) => {
												setGlcode(
													e.target.value
												);
												setGlcodeValid(true);
												hydratePortal({
													op,
													glcode: e.target
														.value,
													getSession,
													history,
													getExternalProviderTransactions,
													queryString: `?glcode=${e.target.value}`,
												});
												// (window.location.href = `${window.location.pathname}?glcode=${e.target.value}`)
											}}
											style={{
												height: 44,
												width: '100%',
												borderRadius: 6,
												border: '1px solid #d3dce0',
												outline: 'none',
												paddingLeft: 8,
												paddingRight: 8,
												fontSize: '1rem',
												fontWeight: 400,
												cursor: 'pointer',
												paddingRight: 10,
											}}
										>
											<option selected disabled>
											<x-lang>Select a department</x-lang>...
											</option>
											{Object.keys(
												state.glcode_list
											).map((item) => {
												return (
													<option
														value={
															state
																.glcode_list[
																item
																].code
														}
														selected={
															state
																.glcode_list[
																item
																].code ===
															state
																.current_glcode
																.code
														}
													>
														{
															state
																.glcode_list[
																item
																].name
														}
													</option>
												);
											})}
										</select>
									</div>
								)}
								{Object.keys(state.fields).map((field) => {
									return (
										<div key={field}>
											<label
												style={{
													color: '#2f343b',

													display: 'flex',
													alignSelf: 'flex-start',
													marginBottom: 8,
												}}
											>
												{state.fields[field].displayName}
											</label>
											<input
												type={state.fields[field].password ? 'password' : 'text'}
												id={`intellipay-${state.fields[field].fieldName}`}

												onChange={(e) => {
													setFieldValue({
														field,
														value: e
															.target
															.value,
													});
													validateFields(
														fields
													);
												}}
												style={{
													height: 40,
													width: 300,
													borderRadius: 6,
													border: '1px solid #d3dce0',
													outline: 'none',
													paddingLeft: 8,
													paddingRight: 8,
													fontSize: '1rem',
													fontWeight: 400,
													marginBottom: 25,
												}}
											/>
										</div>
									);
								})}
								<Button
									variant="contained"
									color="primary"
									disableElevation
									disabled={buttonDisabled}
									onClick={async () => {
										setLoading(true);

										let validateResponse = await validate({
											fields,
											merchantID: state.merchantID,
											isCreateAccount: true,
											reHydratePortal,
											getExternalProviderTransactions,
										});

										if (validateResponse.status === 1) {
											alert(validateResponse.message);
											setView('login');
											setLoginOption('full');
										} else if (validateResponse.status === 2) {
											setView('createAccount');
										} else {
											alert(validateResponse.message);
										}

										setLoading(false);
									}}
									style={{
										width: 200,
										height: 40,
										borderRadius: 25,
										color: 'white',
										marginTop: 40,
									}}
								>
									<x-lang>Validate</x-lang>
								</Button>
								<div style={styles.noAccountBox}>
									<Button
										onClick={() => setView('login')}
										style={{ color: '#1C9BDD' }}
									>
										<x-lang>Back to login</x-lang>
									</Button>
								</div>
							</div>
				</>);
			case 'createAccount':
				return (
					<>
						<img
							src={
								state.merchantLogoURL != '' && state.merchantLogoURL?.split(".com")[1].includes(".")
								? state.merchantLogoURL
								: (state.verticalMarketLogo && state.verticalMarketLogo != ''? state.verticalMarketLogo : "https://secure.cpteller.com/img/logos/CPTellerLogo.png")
							}
							style={{ height: "100%", maxWidth: "95%" }}
							alt={"merchant-logo"}
						/>
						<div 	
							style={{
								display: 'flex',
								flexDirection: 'column',
								alignItems: 'center',
								width: "80%"
							}}
						>
							<label
								className="create-account-label"
							>
								<x-lang>Email</x-lang>
							</label>
							<input
								type="text"
								value={email}
								onChange={(e) => {
									setEmail(e.target.value);
									setEmailValid(ValidateEmail(e.target.value));
								}}
								id="intellipay-email"
								className='create-account-input'
							/>
							<label
								className="create-account-label"
							>
								<x-lang>Username</x-lang>
							</label>
							<input
								type="text"
								value={username}
								onChange={(e) => {
									setUsername(e.target.value);
								}}
								id="intellipay-username-create"
								className='create-account-input'
							/>
							<label
								className="create-account-label"
							>
								<x-lang>Password</x-lang>
							</label>
							<RevealPasswordInput value={password}
								onChange={(e) => setPassword(e.target.value)}
								id="intellipay-password"
								className='create-account-input'
							/>
							<label
								className="create-account-label"
							>
								<x-lang>Retype Password</x-lang>
							</label>
							<RevealPasswordInput value={retypePassword}
								onChange={(e) => setRetypePassword(e.target.value)}
								id="intellipay-password"
								className='create-account-input'
							/>
						</div>

						<Button
							variant="contained"
							color="primary"
							disableElevation
							disabled={
								emailValid &&
								username !== '' &&
								password !== '' &&
								retypePassword !== '' &&
								password === retypePassword
									? false
									: true
							}
							onClick={async () => {
								setLoading(true);

								let createAccountResponse = await createAccount(
									{
										email,
										password,
										username,
									}
								);
								if (createAccountResponse.status === 1) {
									alert('account created');
									setView('login');
									setLoginOption('full');
									setButtonText('Login');
								} else {
									console.log("createAccountResponse", createAccountResponse);
									//check for a message on the createAccountResponse
									if(createAccountResponse.message && createAccountResponse.message != ""){
										alert(createAccountResponse.message);
									}else{
										alert("couldn't create account");
									}
								}

								setLoading(false);
							}}
							style={{
								width: 200,
								height: 40,
								borderRadius: 25,
								color: 'white',
								marginTop: 40,
							}}
						>
							<x-lang>Create Account</x-lang>
						</Button>
						<div style={styles.noAccountBox}>
							<Button
								onClick={() => setView('login')}
								style={{ color: '#1C9BDD' }}
							>
								<x-lang>Back to login</x-lang>
							</Button>
						</div>
					</>
				);
		}
	}


	function setFieldValue({ field, value }) {
		let newFields = fields;
		newFields[field - 1] = {
			[`var${field}`]: value,
		};

		setFields(newFields);
	}

	if (cookies.sessionID && cookies.sessionID !== 'undefined') {
		return <Redirect to={'/invoices'} />;
	} else {
		return (
			<div
				style={ customerBackgroundImage ? 
					{
						...styles.container,
						backgroundImage: customerBackgroundImage,
						backgroundSize: "cover",
						backgroundPosition: "center",
						backgroundRepeat: "no-repeat",
						paddingTop: isTabletOrMobile ? 50 : 0,
					}
					:
					{
					...styles.container,
					backgroundColor: isTabletOrMobile ? 'white' : '#F7F8F9',
					paddingTop: isTabletOrMobile ? 50 : 0,
				}}
			>
				{/* <h1>HELLO</h1> */}
				<div
					style={{
						...styles.loginBox,
						boxShadow: isTabletOrMobile
							? 'none'
							: '0 2px 3px 0 rgba(60, 64, 67, 0.3),0 6px 10px 4px rgba(60, 64, 67, 0.15)',
						width: state.loginMessage ? "fit-content" : "24%" 
					}}
					className="login-box"
				>
			
					{renderView()}
				</div>

			</div>
		);
	}
};

const styles = {
  container: {
    width: "100vw",
    height: "100vh",
    marginBottom: 100,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
    background: "#F7F8F9",
  },
  boxHeader: {
    width: "100%",
    borderBottom: "1px solid #ddd",
    paddingLeft: 40,
    boxSizing: "border-box",
    alignItems: "flex-start",
    display: "flex",
  },
  header: {
    height: 125,
    width: "100vw",
    backgroundColor: "white",
    paddingLeft: "calc((100vw - 1300px)/2)",
    paddingRight: "calc((100vw - 1300px)/2)",
    boxSizing: "border-box",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
  },
  bar: {
    background: "linear-gradient(to right,#004887,#0078a3)",
    height: 50,
    width: "100vw",
    marginBottom: 50,
  },
  linksContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  loginBox: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    backgroundColor: "white",
    borderRadius: 8,
    boxSizing: "border-box",
    boxShadow:
      "0 2px 3px 0 rgba(60, 64, 67, 0.3),0 6px 10px 4px rgba(60, 64, 67, 0.15)",
  },
  loginOption: {
    display: "flex",
    justifyContent: "space-between",
    flexDirection: "row",
    marginBottom: 40,
  },
  inputsContainer: {
    display: "flex",
    alignItems: "center",
    padding: "40px 50px 0px 50px",
    boxSizing: "border-box",
  },
  left: {
    width: "45%",
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
    flexDirection: "column",
    borderRadius: "8px",
    padding: "0px",
  },
  right: {
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
    flexDirection: "column",
    borderRadius: 8,
    marginLeft: 50,
    padding: 25,
  },
  divider: {
    height: 300,
    width: 1,
    backgroundColor: "#ddd",
    marginLeft: 60,
    marginRight: 60,
  },
  noAccountBox: {
    width: "100%",
    textAlign: "center",
    boxSizing: "border-box",
    cursor: "pointer",
  },
};

export default Login;
